import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from 'app/App Store/state';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class ListComponent implements OnInit {

 
  @ViewChild(DatatableComponent) table: DatatableComponent;
  campaignForm:FormGroup

  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;
  user_role: any
  campaign_id:any

  campaign_model ={
    name: '',
    description:'',
    type:'',
    startdate:'',
    enddate:'',
    status:'',
    budget:'',
    ownder:'',
    target:'',
    content:'',
    goals:'',
    kpi:'',
    url:'',
    trackingurl:'',
    results:'',
    analytics:'',
    attachments:'',
    references:'',
    notes: '',
    admin_notes: ''
  }
  minDate:any
  searchVal:any
  @ViewChild('name') inputName;

  guideline_data:any
  pageNumberSubscription : Subscription

  constructor(public apiService:ApiService,
              public toastr: ToastrService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,private formBuilder : FormBuilder,
              private store: Store<AppState> , private router: Router ,
              private activatedRoute : ActivatedRoute
              ) { 
                this.user_role = JSON.parse(localStorage.getItem('user'))
                let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'Campaigns') 
                this.guideline_data = key_data[0]?._id

                this.activatedRoute.queryParamMap.subscribe((params) => {
                  let page = +params.get('page');
                  this.setPage(page)
                });
                this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
                .subscribe(pageNumber => {
                  this.page.pageNumber = pageNumber;
                  if(pageNumber !==undefined){
                    this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                  }
                });


              }

  ngOnInit(): void {
    this.getCampaignList()
    this.campaignForm = this.formBuilder.group({
      name:  ['',],
      description: ['',],
      type: ['',],
      startdate: ['',],
      enddate: ['',],
      status: ['',],
      budget: ['',],
      ownder: ['',],
      target: ['',],
      content: ['',],
      goals: ['',],
      kpi: ['',],
      url: ['',],
      trackingurl: ['',],
      results: ['',],
      analytics: ['',],
      attachments: ['',],
      references: ['',],
      notes:  ['',],
      admin_notes:  ['',]
    })

    const today_date = new Date();
    this.minDate = today_date.toISOString().split('T')[0];
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  getCampaignList() {
    this.spinner.show(undefined,
     {
       type: 'ball-triangle-path',
       size: 'medium',
       bdColor: 'rgba(0, 0, 0, 0.8)',
       color: '#fff',
       fullScreen: true
     });
   // let status = this.type_List.find((item) => item.name == this.activeTab);
   this.apiService.getAllCampaign(this.page.pageNumber+1,this.limitRef).subscribe((res: any) => {
     this.spinner.hide()
     this.rows = res?.data?.items
     this.page.totalPages=res?.data?.totalCount
   })
 }
 pageChangeData(page:any) {
  this.router.navigate([], {
    relativeTo: this.activatedRoute,
    queryParams: { page: page.offset +1 },
    queryParamsHandling: 'merge' // keep existing query params
  });
   this.apiService.getAllCampaign(page.offset +1,page.pageSize).subscribe((res:any)=>{
    this.setPage(page.offset +1)
     this.rows =res.data.items
     this.page.totalPages=res.data.totalCount
   }) 
 }
 open(content, id,data) {
  if(id !='' && data !=''){
    this.campaign_id =id
    this.campaign_model.name = data.name
    this.campaign_model.description = data.description
    this.campaign_model.type = data.type
    this.campaign_model.startdate = data.startdate
    this.campaign_model.enddate = data.enddate
    this.campaign_model.status = data.status
    this.campaign_model.budget = data.budget
    this.campaign_model.ownder = data.ownder
    this.campaign_model.target = data.target
    this.campaign_model.content = data.content
    this.campaign_model.goals = data.goals
    this.campaign_model.kpi = data.kpi
    this.campaign_model.url = data.url
    this.campaign_model.trackingurl = data.trackingurl
    this.campaign_model.results = data.results
    this.campaign_model.analytics = data.analytics
    this.campaign_model.attachments = data.attachments
    this.campaign_model.references = data.references
    this.campaign_model.notes = data.notes
    this.campaign_model.admin_notes = data.admin_notes

  }
  
  const modalOptions: NgbModalOptions = {
    size: 'lg' // 'sm', 'lg', or 'xl'
  };
    const modalRef = this.modalService.open(content,modalOptions);
    
    modalRef.result.then((result) => {
      this.campaign_id =''
      this.campaignForm.reset()
      this.campaign_model.name =''
      this.campaign_model.description = ''
      this.campaign_model.type = ''
      this.campaign_model.startdate = ''
      this.campaign_model.enddate = ''
      this.campaign_model.status = ''
      this.campaign_model.budget = ''
      this.campaign_model.ownder = ''
      this.campaign_model.target = ''
      this.campaign_model.content = ''
      this.campaign_model.goals = ''
      this.campaign_model.kpi = ''
      this.campaign_model.url = ''
      this.campaign_model.trackingurl = ''
      this.campaign_model.results = ''
      this.campaign_model.analytics = ''
      this.campaign_model.attachments = ''
      this.campaign_model.references = ''
      this.campaign_model.notes = ''
      this.campaign_model.admin_notes = ''
    }, (reason) => {
      this.campaign_id =''
      this.campaignForm.reset()
      this.campaign_model.name =''
      this.campaign_model.description = ''
      this.campaign_model.type = ''
      this.campaign_model.startdate = ''
      this.campaign_model.enddate = ''
      this.campaign_model.status = ''
      this.campaign_model.budget = ''
      this.campaign_model.ownder = ''
      this.campaign_model.target = ''
      this.campaign_model.content = ''
      this.campaign_model.goals = ''
      this.campaign_model.kpi = ''
      this.campaign_model.url = ''
      this.campaign_model.trackingurl = ''
      this.campaign_model.results = ''
      this.campaign_model.analytics = ''
      this.campaign_model.attachments = ''
      this.campaign_model.references = ''
      this.campaign_model.notes = ''
      this.campaign_model.admin_notes = ''
    });
 }
 submit(){
  
  if(!this.campaign_id){
    this.apiService.addCampaign(this.campaignForm.value).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res.message)
        this.modalService.dismissAll()
        this.getCampaignList()
      }
      else this.toastr.error(res.error)
    })
  }
  if(this.campaign_id){
    this.campaign_model.startdate = this.campaignForm.value.startdate
    this.campaign_model.enddate = this.campaignForm.value.enddate
    this.apiService.updateCampaign(this.campaign_id,this.campaign_model).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success('update successfull!')
        this.modalService.dismissAll()
        this.getCampaignList()
      }
      else this.toastr.error(res.error)
    })
  }
 }
 campaignDelete() {
  if (this.campaign_id) {
    this.apiService.deleteCampaign(this.campaign_id).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your imaginary file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getCampaignList()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Erorr!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    })
  }
  else {
    this.toastr.error('something went wrong !!')
  }
}
// ================== Delete Alert ========================
ConfirmColor(id: any) {
  this.campaign_id = id
  swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to delete this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#2F8BE6',
    cancelButtonColor: '#F55252',
    confirmButtonText: 'Yes, delete it!',
    customClass: {
      confirmButton: 'btn btn-warning',
      cancelButton: 'btn btn-danger ml-1'
    },
    buttonsStyling: false,
  }).then((result) => {
    if (result.value) {
      this.campaignDelete()
    
    } else if (result.dismiss === swal.DismissReason.cancel) {
      swal.fire({
        title: 'Cancelled',
        text: 'Your imaginary file is safe :)',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        },
      })
    }
  });
}
filter(val){
  this.apiService.filterCampaign(val).subscribe((res:any)=>{
    this.rows = res?.data
    this.page.totalPages = res?.data?.length
  })
}
resetFilter(){
 this.inputName.nativeElement.value = null;
 this.getCampaignList()

}
openDynamicModal(key_id:string) {
  const modalOptions: NgbModalOptions = {
    size: 'lg', // 'sm', 'lg', or 'xl'
    backdrop: 'static',
  };
  const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
  modalRef.componentInstance.key_id = key_id;
}

}
